﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as nouislider from 'nouislider';

import helper_infopage from '../../../helper/infopage';

import tpl_rss from './tpl/rss.html';

export default Marionette.ItemView.extend({
    dialogRegion: '#rss_modal',
    errors: [],
    getTemplate: function () {
        return tpl_rss({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;
    },
    ui: {
        'rss_checkboxFeedType': '#rss_checkboxFeedType',
        'rss_dropDown_feedProvider': '#rss_dropDown_feedProvider',
        'rss_input_feedUrl': '#rss_input_feedUrl',
        'rss_dropDown_feedCount': '#rss_dropDown_feedCount',
        'rss_input_feedSpeed': '#rss_input_feedSpeed',
        'rss_select_Font1_ColorType': '#rss_select_Font1_ColorType',
        'rss_ColorPickerSliders_Font1_Color': '#rss_ColorPickerSliders_Font1_Color',
        'rss_select_Font1_FontType': '#rss_select_Font1_FontType',
        'rss_dropDown_Font1': '#rss_dropDown_Font1',
        'rss_formgroup_Font1': '#rss_formgroup_Font1',
        'rss_dropDown_Font1_Size': '#rss_dropDown_Font1_Size',
        'rss_dropDown_Font1_Style': '#rss_dropDown_Font1_Style',
        'module_input_ModuleMargin_Top': '#module_input_ModuleMargin_Top',
        'module_input_ModuleMargin_Bottom': '#module_input_ModuleMargin_Bottom',
        'module_input_ModuleMargin_Left': '#module_input_ModuleMargin_Left',
        'module_input_ModuleMargin_Right': '#module_input_ModuleMargin_Right',
    },
    events: {
        'change @ui.rss_select_Font1_FontType': 'change_Font1_FontType',
        'change @ui.rss_select_Font1_ColorType': 'change_Font1_ColorType',
        'colorpickerChange @ui.rss_ColorPickerSliders_Font1_Color': 'colorChange_Font1Color',
        'click #rss_btn01': 'onBtn01',
        'click #rss_btn02': 'onBtn02'
    },
    onRender: function () {
    },
    onAttach() {
        this.setupFeedProviderType();
        this.setupFeedProvider();
        this.setupFeedCount();
        this.setupFeedSpeed();
        this.setupFontColorType();
        this.setupFontType();
        this.setupFont();
        this.setupFontSize();
        this.setupFontStyle();
    },
    setupFeedProviderType: function () {
        var checked = this.model.attributes.FeedType == 1 ? true : false;
        this.ui.rss_checkboxFeedType.attr('checked', checked);
    },
    setupFeedProvider: function () {
        var self = this;

        this.ui.rss_dropDown_feedProvider.empty();

        var selected = '';

        self.app.entities.collections.FeedProvider.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.FeedProvider == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.rss_dropDown_feedProvider.append(options);
        });
    },
    setupFeedCount: function () {
        var self = this;

        this.ui.rss_dropDown_feedCount.empty();

        var selected = '';

        self.app.entities.collections.FeedCount.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.FeedCount == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.rss_dropDown_feedCount.append(options);
        });
    },
    setupFeedSpeed: function () {
        var self = this;

        if ($("#rss_input_feedSpeed").length) {
            var startSlider = document.getElementById('rss_input_feedSpeed');
            nouislider.create(startSlider, {
                start: self.model.attributes.FeedSpeed,
                connect: [true, false],
                range: {
                    min: 50,
                    max: 300
                },
                step: 1
            });
            startSlider.noUiSlider.on('set', function (e) {
                self.model.attributes.FeedSpeed = parseInt(e);
            });
        }
    },
    setupFontColorType: function () {
        var self = this;

        self.ui.rss_select_Font1_ColorType.empty();

        var selected = '';

        self.app.entities.collections.InfoFontColorType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font1_ColorType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.rss_select_Font1_ColorType.append(options);
        });
    },
    setupFontType: function () {
        var self = this;

        self.ui.rss_select_Font1_FontType.empty();

        var selected = '';

        self.app.entities.collections.InfoFontType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font1_FontType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.rss_select_Font1_FontType.append(options);
        });

    },
    setupFont: function () {
        var self = this;

        var fonts = [];

        self.app.entities.collections.Font.forEach(function (entry) {
            fonts.push(entry.attributes.data_font_family);
        });

        this.ui.rss_ColorPickerSliders_Font1_Color.colorpicker({
            color: self.model.attributes.Font1_Color,
            format: "rgb"
        });

        switch (helper_infopage.getSelectedColor_enabled(this.model.attributes.Font1_ColorType)) {
            case true: this.ui.rss_ColorPickerSliders_Font1_Color.colorpicker('colorpicker').enable(); break;
            case false: this.ui.rss_ColorPickerSliders_Font1_Color.colorpicker('colorpicker').disable(); break;
        }

        this.ui.rss_dropDown_Font1.fontselect({
            googleFonts: fonts
        }).on('change', function () {
            self.model.set({ Font1: this.value });
            self.model.set({ Font1_Select: this.value });
        });
        this.ui.rss_dropDown_Font1.trigger('setFont', self.model.attributes.Font1);

        switch (helper_infopage.getSelectedFont_enabled(this.model.attributes.Font1_FontType)) {
            case false: this.ui.rss_formgroup_Font1.addClass('disabledFontSelect_FormGroup');
                this.ui.rss_formgroup_Font1.find('.font-select').addClass('disabledFontSelect_FontSelect');
                break;
            case true: this.ui.rss_formgroup_Font1.removeClass('disabledFontSelect_FormGroup');
                this.ui.rss_formgroup_Font1.find('.font-select').removeClass('disabledFontSelect_FontSelect');
                break;
        }
    },
    setupFontSize: function () {
        var self = this;

        this.ui.rss_dropDown_Font1_Size.empty();

        var selected = '';

        for (var i = 10; i <= 200; i++) {
            selected = '';

            if (self.model.attributes.Font1_Size == String.format('{0}{1}', i, 'px')) {
                selected = 'selected = "selected"';
            }

            var options = String.format('<option {1}>{0}px</option>', i, selected);
            this.ui.rss_dropDown_Font1_Size.append(options);
        }
    },
    setupFontStyle: function () {
        var self = this;
        self.ui.rss_dropDown_Font1_Style.empty();

        var selected = '';

        self.app.entities.collections.FontStyle.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font1.Style == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.rss_dropDown_Font1_Style.append(options);
        });
    },
    onBtn01: function () {
        var self = this;

        self.setModel();

        var callback = function () {
            self.trigger("dialog:close");
            self.triggerMethod('dialog:btn01clicked', "msg");
        }

        this.validate(callback);
    },
    onBtn02: function () {
        this.triggerMethod('dialog:btn02clicked', "msg");
        this.trigger("dialog:close");
    },
    showErrors: function (errors) {
        _.each(errors, function (error) {
            var controlGroup = this.$('.' + error.name);
            controlGroup.addClass('error');
            controlGroup.find('.help-inline').text(error.message);
        }, this);
    },
    hideErrors: function () {
        this.$('.control-group').removeClass('error');
        this.$('.help-inline').text('');

        this.errors = [];
    },
    validate: function (callback) {
        var self = this;
        this.hideErrors();
        callback();
    },
    change_Font1_FontType: function () {
        this.model.set({
            Font1_FontType: this.ui.rss_select_Font1_FontType.val()
        });

        this.model.set({
            Font1: helper_infopage.getSelectedFont(this.app, this.model.attributes.Font1_FontType, this.model.attributes.Font1_Select)
        });

        this.ui.rss_dropDown_Font1.trigger('setFont', this.model.attributes.Font1);

        switch (helper_infopage.getSelectedFont_enabled(this.model.attributes.Font1_FontType)) {
            case false: this.ui.rss_formgroup_Font1.addClass('disabledFontSelect_FormGroup');
                this.ui.rss_formgroup_Font1.find('.font-select').addClass('disabledFontSelect_FontSelect');
                break;
            case true: this.ui.rss_formgroup_Font1.removeClass('disabledFontSelect_FormGroup');
                this.ui.rss_formgroup_Font1.find('.font-select').removeClass('disabledFontSelect_FontSelect');
                break;
        }
    },
    change_Font1_ColorType: function () {
        this.model.set({
            Font1_ColorType: this.ui.rss_select_Font1_ColorType.val()
        });

        this.model.set({
            Font1_Color: helper_infopage.getSelectedColor(this.app, this.model.attributes.Font1_ColorType, this.model.attributes.Font1_ColorSelect)
        });

        this.ui.rss_ColorPickerSliders_Font1_Color.colorpicker('colorpicker').enable();
        this.ui.rss_ColorPickerSliders_Font1_Color.colorpicker('colorpicker').setValue(this.model.attributes.Font1_Color);

        switch (helper_infopage.getSelectedColor_enabled(this.model.attributes.Font1_ColorType)) {
            case true: this.ui.rss_ColorPickerSliders_Font1_Color.colorpicker('colorpicker').enable(); break;
            case false: this.ui.rss_ColorPickerSliders_Font1_Color.colorpicker('colorpicker').disable(); break;
        }
    },
    colorChange_Font1Color: function (e) {
        if (typeof e.value === 'string') {
            this.model.attributes.Font1_Color = e.value;
        }
        else {
            this.model.attributes.Font1_Color = e.value.toRgbString();
        }

        if (helper_infopage.getSelectedColor_enabled(this.model.attributes.Font1_ColorType)) {
            this.model.attributes.Font1_ColorSelect = this.model.attributes.Font1_Color;
        }
    },
    setModel: function () {

        var FeedType = this.model.attributes.FeedType;
        this.ui.rss_checkboxFeedType.is(':checked') ? FeedType = 1 : FeedType = 0;

        var a = this.ui.rss_dropDown_feedCount.val();

        this.model.set({
            FeedType: FeedType,
            FeedProvider: this.ui.rss_dropDown_feedProvider.val(),
            FeedUrl: this.ui.rss_input_feedUrl.val(),
            FeedCount: this.ui.rss_dropDown_feedCount.val(),
            Font1_ColorType: this.ui.rss_select_Font1_ColorType.val(),
            Font1_FontType: this.ui.rss_select_Font1_FontType.val(),
            Font1: this.ui.rss_dropDown_Font1.val(),
            Font1_Size: this.ui.rss_dropDown_Font1_Size.val(),
            Font1_Style: this.ui.rss_dropDown_Font1_Style.val(),
            ModuleMargin_Top: this.ui.module_input_ModuleMargin_Top.val(),
            ModuleMargin_Bottom: this.ui.module_input_ModuleMargin_Bottom.val(),
            ModuleMargin_Left: this.ui.module_input_ModuleMargin_Left.val(),
            ModuleMargin_Right: this.ui.module_input_ModuleMargin_Right.val()
        });
    }
});